import * as angular from 'angular';
import { CourseDiffsAndGapPlansTable } from './course-diffs-and-gap-plans-table.component';

export const CourseDiffsAndGapPlansTableModule = angular
  .module('courseDiffsAndGapPlansTable', [])
  .component('courseDiffsAndGapPlansTable', CourseDiffsAndGapPlansTable).name;
